import eyeIcon from "../Assets/icons/eye 1.svg";
import editIcon from "../Assets/icons/Un-Checkbox.svg";

export const TABLE_HEADERS = [
  "Lead ID",
  "Customer Name",
  "Contact No.",
  "Visit Date & Time",
  "Location",
  "Product",
  "Make",
  "Model",
  "Variant",
  "Color",
  "Actions",
];

export const TABLE_DATA = [
  {
    id: 1,
    leadId: "1045",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 2,
    leadId: "1046",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 3,
    leadId: "1047",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 4,
    leadId: "1048",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 5,
    leadId: "1049",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
  {
    id: 6,
    leadId: "1050",
    customerName: "Pinky Gupta",
    conatctNo: "+919833456896",
    visitDateAndTime: "2023-08-11:30 am",
    loaction: "Thane, Mumbai",
    product: "Scooter",
    make: "TVS Apache",
    model: "RTR 160",
    variant: "Rear Drum",
    color: "Black",
    actions: "Edit/Delete",
  },
];

export const keyMapping = {
  "Lead ID": "leadId",
  "Customer Name": "customerName",
  "Contact No.": "conatctNo",
  "Visit Date & Time": "visitDateAndTime",
  Location: "loaction",
  Product: "product",
  Make: "make",
  Model: "model",
  Variant: "variant",
  Color: "color",
  Actions: [
    { type: "edit", icon: editIcon, label: "Edit" },
    { type: "view", icon: eyeIcon, label: "View" },
  ],
};

export const topDataList = [
  { id: 1, title: "Vehicles Sold", value: "180" },
  { id: 2, title: "Sales Performance", value: "20%" },
  { id: 3, title: "Conversion Rate", value: "10%" },
  { id: 4, title: "Sales Growth Rate", value: "50%" },
  { id: 5, title: "Sales Revenue", value: "₹30 Lac" },
];
